module.exports = __webpack_public_path__ + "img/6-2.360c7322.png";